var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('aside',{staticClass:"aside"},[_c('div',{staticClass:"aside__inner"},[_c('div',{staticClass:"aside__inner__section"},[_c(_setup.CompanyDetails)],1),(_setup.store.getters.isPremiumEnterprise)?_c('div',{staticClass:"aside__inner__section"},[_c(_setup.Updates)],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }